import classNames from "classnames";
import { Entry } from "contentful";

import Editorials from "~/types/editorials";
import { assertEditorialType, isActiveEntry } from "~/utils/editorial-utils";

import MediaAsset from "../common/media-asset";
import styles from "./navigation-menu.module.scss";
import NavigationMenuGroup from "./navigation-menu-group";

type Props = {
  menu: Entry<Editorials.Menu>;
};

export default function NavigationMenu(props: Props) {
  const imageLarge = props.menu.fields.imageLarge;
  const mainMenu = props.menu.fields.main?.filter(isActiveEntry);

  return (
    <div className={imageLarge && styles.wrapperContainer}>
      <div className={styles.menuContainer}>
        {props.menu.fields.highlight && (
          <div className={classNames(styles.highlightCol, imageLarge && styles.increasePaddingRight)}>
            {props.menu.fields.highlight?.filter(isActiveEntry).map((el, i) => (
              <NavigationMenuGroup key={i} menuGroup={el} />
            ))}
          </div>
        )}
        <div
          className={styles.mainCol}
          style={{
            gridTemplateColumns: imageLarge && `repeat(${mainMenu.length}, 1fr)`,
          }}
        >
          {mainMenu.map((el, i) => {
            const lastChildWithImage = imageLarge && i === mainMenu.length - 1;

            if (el.sys.contentType.sys.id == "menuColumn") {
              assertEditorialType<Editorials.MenuColumn>(el, "menuColumn");
              return (
                <div
                  key={i}
                  className={classNames(
                    styles.mainGroup,
                    styles.menuColumn,
                    lastChildWithImage && styles.increasePaddingRight
                  )}
                >
                  {el.fields.items?.filter(isActiveEntry).map((group, index) => (
                    <NavigationMenuGroup key={index} menuGroup={group} />
                  ))}
                </div>
              );
            } else {
              assertEditorialType<Editorials.MenuGroup>(el, "menuGroup");
              return (
                <NavigationMenuGroup
                  classNames={classNames(styles.mainGroup, lastChildWithImage && styles.increasePaddingRight)}
                  key={i}
                  menuGroup={el}
                />
              );
            }
          })}
        </div>
      </div>
      {imageLarge && (
        <div className={styles.wrapperImage}>
          <MediaAsset entry={imageLarge} />
        </div>
      )}
    </div>
  );
}
